import moment, { Moment } from 'moment-timezone';

// adding alias to avoid confusion with payments given this is drawdown related
import { PaymentDateOptionsDto as DrawdownDateOptionsDto } from '@alpha/payments-dtos';

const isAfterMigrationDate = (
  formattedDate: string,
  migrationDate?: string,
): boolean => {
  const date = migrationDate
    ? moment(migrationDate).format('YYYY-MM-DD')
    : undefined;

  return date
    ? moment(formattedDate).isAfter(date)
      || (moment(formattedDate).isSame(date)
        && moment.tz('Europe/London').isAfter(moment.tz(migrationDate, 'Europe/London')))
    : false;
};

const calculateDisableDrawdownDates = (
  _date: Moment,
  valueDate?: string,
  dateOptions?: DrawdownDateOptionsDto,
  corpayMigrationEndDate?: string,
): boolean => {
  const defaultTimezone = moment.tz.guess();
  const formattedDate = _date.tz(defaultTimezone).format('YYYY-MM-DD');

  const isAfterMigrationCutOff = !!corpayMigrationEndDate
    && isAfterMigrationDate(formattedDate, moment(corpayMigrationEndDate).subtract(3, 'days').format('YYYY-MM-DD'));

  if (dateOptions) {
    const todayDate = moment.tz('Europe/London').format('YYYY-MM-DD');

    const notHolidays = dateOptions.holidays?.some((holiday) => moment(holiday.date).tz('Europe/London').format('YYYY-MM-DD') === formattedDate);
    _date.tz(defaultTimezone);

    if (
      valueDate && valueDate !== '' && moment(valueDate).isBefore(todayDate)
      && (moment(formattedDate).isBefore(todayDate)
      || moment(formattedDate).isAfter(todayDate))
    ) {
      return true;
    }

    return (
      moment(formattedDate).isBefore(todayDate)
      || moment(formattedDate).isBefore(dateOptions.earliestDate)
      || moment(formattedDate).isAfter(dateOptions.latestDate)
      || notHolidays
      || isAfterMigrationCutOff
    );
  }

  return isAfterMigrationCutOff;
};

export default calculateDisableDrawdownDates;
